export const COMMON = {
  ALERT_MESSAGE: "ALERT_MESSAGE",
  LOADING: "LOADING",
  CUSTOMER_CURRENT_TAB: "CUSTOMER_CURRENT_TAB",
  EMPLOYEE_CURRENT_TAB: "EMPLOYEE_CURRENT_TAB",
  SETTING_CURRENT_TAB: "SETTING_CURRENT_TAB",
  RENT_REQUEST_CURRENT_TAB: "RENT_REQUEST_CURRENT_TAB",
  RETURN_REQUEST_CURRENT_TAB: "RETURN_REQUEST_CURRENT_TAB",
  RENT_DETAIL_CURRENT_TAB: "RENT_DETAIL_CURRENT_TAB",
  RETURN_DETAIL_CURRENT_TAB: "RETURN_DETAIL_CURRENT_TAB",
  DEVICE_DETAIL_CURRENT_TAB: "DEVICE_DETAIL_CURRENT_TAB",
  INVENTORY_DETAIL_CURRENT_TAB: "INVENTORY_DETAIL_CURRENT_TAB",
  PRICElIST_CURRENT_TAB: "PRICElIST_CURRENT_TAB",
  MAINTAIN_CURRENT_TAB: "MAINTAIN_CURRENT_TAB",
  MAINTAIN_DETAIL_CURRENT_TAB: "MAINTAIN_DETAIL_CURRENT_TAB",
  MANAGE_DEVICE_CURRENT_TAB: "MANAGE_DEVICE_CURRENT_TAB",
  URL_IMAGE: "URL_IMAGE",
  IS_STICKY_BTN: "IS_STICKY_BTN",
  COUNT_UNREAD: "COUNT_UNREAD",
};
